import { render, staticRenderFns } from "./TrainingPlanSuccess.vue?vue&type=template&id=80b324a8&scoped=true&"
import script from "./TrainingPlanSuccess.vue?vue&type=script&lang=js&"
export * from "./TrainingPlanSuccess.vue?vue&type=script&lang=js&"
import style0 from "./TrainingPlanSuccess.vue?vue&type=style&index=0&id=80b324a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80b324a8",
  null
  
)

export default component.exports